import React from 'react';
import { Select, MenuItem, Checkbox } from '@mui/material';

const MultiSelectDropDown = (props) => {
    return (
        <Select
            fullWidth={!props.width}
            variant="outlined"
            multiple
            displayEmpty
            value={props.value}
            renderValue={(selected) => {
                if (selected.length === 0) {
                    return props.placeHolder;
                }
                return selected.join(', ');
            }}
            style={{ 
                textAlign: 'left', 
                color: props.value.length === 0 ? '#B0B0B0' : 'black', 
                fontSize: '0.9rem',
                height: props.height ? props.height : "2rem",
                width: props.width ? props.width : undefined,
                padding: "0.2rem",
                paddingLeft: "0rem",
                boxShadow: "0 0.2rem 0.4rem 0 #D3D3D3"
            }}
            onChange={(e) => {
                const { target: { value } } = e;
                props.setFunc(typeof value === 'string' ? value.split(',') : value);
            }}
            MenuProps={{
                ...props.MenuProps,
                PaperProps: {
                    ...props.MenuProps?.PaperProps,
                    style: { maxHeight: '250px', ...props.MenuProps?.PaperProps?.style },
                    sx: {
                        "&::-webkit-scrollbar": { display: "none" },
                        scrollbarWidth: "none",
                        ...props.MenuProps?.PaperProps?.sx
                    }
                }
            }}
        >
            <MenuItem value={props.placeHolder} disabled>{props.placeHolder}</MenuItem>
            {props.list.map((item) => (
                <MenuItem key={item.name} value={item.name} style={{ minHeight: '2em' }}>
                    <Checkbox checked={props.value.indexOf(item.name) > -1} style={{padding: '0rem 0.3rem 0rem 0rem'}} />
                    {item.name}
                </MenuItem>
            ))}
        </Select>
    );
};

export default MultiSelectDropDown;